"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const Inner_1 = require("./Inner");
const hooks_1 = require("../../hooks");
exports.ConversionCanvasToolbar = () => {
    const { dispatchCanvasAction } = hooks_1.useConversionCanvasUpdate();
    const { prefs: { view }, state: { draft }, } = hooks_1.useConversionCanvas();
    return (react_1.default.createElement(Inner_1.ConversionCanvasToolbarInner, { dispatchCanvasAction: dispatchCanvasAction, draft: draft, view: view }));
};
//# sourceMappingURL=index.js.map